import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { DocumentationPMPreStageComponent } from './documentation-pm-pre-stage.component';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '@infrastructure/objectUtils';

import { ControlContainer, NgForm } from '@angular/forms';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { DocumentsHandlerService } from '@infrastructure/Documents/DocumentHandlerService';
import { AlertService } from '@infrastructure/Alerts/alert.service';
import { LoadingMaskService } from '@infrastructure/LoadingMask/LoadingMaskService';
import { SubscriberInformationService } from '@infrastructure/SubscriberInfo/SubscriberInformationService';
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs';
import { TranslateService } from '@ngx-translate/core';
import { BeneficiaryItem } from '@infrastructure/Models/beneficiary-item';
import { PersonType } from '@infrastructure/Models/const.personType';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { StateCode, StatePhase } from '@infrastructure/Models/const.stateCodePhase';
import { LegalRepresentationState } from '../../../_infrastructure/Beneficiaries/legal-representation-state.service';
//import { PreStageDocumentationComponent } from '../../../workflow-instance-creator/documentation/prestage-documentation.component';

@Component({
  selector: 'documentation-table-edit-pm-pre-stage',
  templateUrl: './documentation-table-edit-pm-pre-stage.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})
export class DocumentationTableEditPMPreStageComponent extends TableEditBase<models.DocumentVM_PM> implements OnInit, OnDestroy {

  //@CommonData(DomainCodes.domains)
  //public domains: models.DimensionVM[];
  //@CommonData(DomainCodes.fileTypes)
  //public fileTypes: models.DimensionVM[];
  //@CommonData(DomainCodes.documentDesignationType)
  //public designationTypes: models.DimensionVM[];

  @Input() public isMandatoryDocumentation : boolean;
  @Input() public isWorkflowOnSubscriber : boolean;
  @Input() public isReadonly: boolean = false;
  @Input() public isIncapacity: boolean = false;
  @Input() public isWorkflowMandatory: boolean = false;
  @Input() public workflowInstanceId: number;
  @Input() beneficiaryList: models.BeneficiaryListVM[] = <models.BeneficiaryListVM[]>{};
  @Input() senderIdentification: models.SenderIdentificationVM = <models.SenderIdentificationVM>{};
  @Input() deceasedIdentification: models.DeceasedIdentificationVM = <models.DeceasedIdentificationVM>{};
  @Input() dropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};

  @Input() instanceRole: string;

  @Input() isDiferida: boolean;
  @Input() stateCode: string;
  @Input() statePhase: string;

  //@Input() subscriberNumber: string;

  public uploadedFile: File;
  //public subscriber: models.SubscriberInformationVM;
  public invalidFileFormat: boolean = false;
  public invalidFileSize: boolean = false;
  public invalidExceedsFileSize: boolean = false;
  public invalidPDFFile: boolean = false;
  public beneficiariesList: BeneficiaryItem[] = [];
  public designationTypes: models.Options[] = [];
  public documentsValue = DropdownsValues.dropListDocuments;

  private MAX_FILE_SIZE: number = 8388608;

  public isStateDevolvidoAoRemetente: boolean;

  public isRLIndeferida: boolean = false;
  public isStateInvalidado: boolean = false;
  public isAIndeferir: boolean = false;
  constructor(@Inject(DocumentationPMPreStageComponent) private parent: Component, private modalService: ModalService,
    private documentService: DocumentsHandlerService, private alertService: AlertService,
    private loadingMaskService: LoadingMaskService,
    private beneficiariesValuesService: BeneficiaryValuesService,
     private http: HttpClient) {
    super(parent, modalService);
    
    //this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => {
    //  this.subscriber = subscriber;
    //});
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.uploadedFile = null;
    this.beneficiariesList = this.beneficiariesValuesService
      .buildBeneficiariesItemList(this.beneficiaryList, this.deceasedIdentification, this.senderIdentification, this.itemList);
   // this.buildBeneficiariesList();
    this.getFilteredDesignationTypes();
    if (this.stateCode == StateCode.Ativo && this.statePhase == StatePhase.DevolvidoAoRemetente) {
      this.isStateDevolvidoAoRemetente = true;
    }
    if (this.stateCode == StateCode.Invalidado && this.statePhase == StatePhase.RLIndeferida) {
      this.isRLIndeferida = true;
    }
    if (this.stateCode == StateCode.Invalidado || this.stateCode == StateCode.Pendente) {
      this.isStateInvalidado = true;
    }

    const beneficiary = this.beneficiaryList.find(ben => ben.beneficiaryID == this.item.beneficiaryID);
    if (beneficiary != null && beneficiary != undefined) {
      if (beneficiary?.stateRL == LegalRepresentationState.AIndeferir) {
        this.isAIndeferir = true;
      }
    }
  }

  ngOnDestroy(): void {
  }

  //private buildBeneficiariesList() {
  //  this.beneficiariesList = this.beneficiaryList
  //    .map(el => {
  //      const newBeneficiary: BeneficiaryItem = {
  //        value: el.beneficiaryID,
  //        description: el.beneficiaryName,
  //        name: el.beneficiaryName,
  //        type: "Beneficiary"
  //      };
  //      return newBeneficiary;
  //    });

  //  // Add the deceased to the list
  //  const deceasedIdentification = this.deceasedIdentification;
  //  const deceased: BeneficiaryItem = {
  //    value: PersonType.Deceased,
  //    description: deceasedIdentification.subscriberName,
  //    name: deceasedIdentification.subscriberName,
  //    type: "Deceased"
  //  };
  //  this.beneficiariesList.push(deceased);

  //  //Add sender if not on the list
  //  const senderIdentification = this.senderIdentification;
  //  const existeOnListDoc = this.itemList.filter(el => el.ownerName == senderIdentification.name &&
  //    el.beneficiaryID == PersonType.Sender).length > 0;
  //  const existeOnListBeneficiaries = this.beneficiariesList.filter(el => el.name == senderIdentification.name &&
  //    el.value == PersonType.Sender).length > 0;

  //  if (!existeOnListDoc || !existeOnListBeneficiaries) {
  //    const sender: BeneficiaryItem = {
  //      value: PersonType.Sender,
  //      description: senderIdentification.name + " - Remetente",
  //      name: senderIdentification.name,
  //      type: "Sender"
  //    };
  //    this.beneficiariesList.push(sender);

  //  }
  //}

  private getFilteredDesignationTypes() {
    let parentDropdowns = this.dropdowns;
    for (let i = 0; i < parentDropdowns.options.length; i++) {
      if (parentDropdowns.options[i]['dropdown'] === 'dropListDocuments') {
        if (!this.isWorkflowMandatory) {
          if (this.isWorkflowOnSubscriber) {
            if (parentDropdowns.options[i]['type'] === '002')
              this.designationTypes.push(parentDropdowns.options[i]);
          } else {
            if (parentDropdowns.options[i]['type'] === '001')
              this.designationTypes.push(parentDropdowns.options[i]);
          }
        } else {
          if (parentDropdowns.options[i]['type'] === '001' || parentDropdowns.options[i]['type'] === '002')
            this.designationTypes.push(parentDropdowns.options[i]);
        }
      }
    }
  }

  public onBlurOwnerSelect() {
    const beneficiary = this.beneficiaryList.find(ben => ben.beneficiaryID == this.item.beneficiaryID);
    let show = false;
    if (isNotNullOrUndefinedOrEmpty(beneficiary)) {
      show = beneficiary?.stateRL == LegalRepresentationState.RepresentacaoDeferida ||
        beneficiary?.stateRL == LegalRepresentationState.RepresentaçaoIndeferida ||
        beneficiary?.stateRL == LegalRepresentationState.AIndeferir;
    }
    if (show ) {
      let modal = <models.BaseModalVM>{
        isError: false,
        message: "WorkflowCreatePM.PreStage.Documents.DocumentosNovosWarning",
        param: {},
        cancelButton: {
          hideButton: true,
          buttonText: "Ok",
          buttonClass: 'btn-primary',
          iconClass: "icon-check"
        }
      };

      this.modalService.showModals([modal]).subscribe(res => this.item.beneficiaryID = null);
    }
  }

  onFileSelected(event: any) {
    this.setFile(event.target.files[0]);
  }

  onFileDropped(file: File) {
    this.setFile(file);
  }

  private async setFile(file: File) {
    this.invalidFileFormat = false;
    this.invalidFileSize = false;
    this.invalidPDFFile = false;

    if (!this.validatePDFFile(file)) {
      this.invalidFileFormat = true;
      return;
    } else if (this.validatePDFExceedsFileSize(file)) {
      this.invalidExceedsFileSize = true;
      return;
    } else {
      let fileCheck = await this.checkIfFileIsEmpty(file);
      if (fileCheck === "EmptyPDF") {
        this.invalidFileSize = true;
        return;
      } else if (fileCheck === "InvalidPDF") {
        this.invalidPDFFile = true;
        return;
      }
    }

    this.uploadedFile = file;
    this.item.fileName = this.uploadedFile.name;
    this.item.fileSizeKB = Math.round(this.uploadedFile.size / 1024);
    this.item.file = this.uploadedFile;
    if (!this.item.filePath) {
      this.item.filePath = this.uploadedFile.name;
    }
    
  }

  private validatePDFExceedsFileSize(file: File) {
    return file.size > this.MAX_FILE_SIZE;
  }

  private validatePDFFile(file: File) {
    return file.type === 'application/pdf';
  }

  private async checkIfFileIsEmpty(file: File):Promise<string>  {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'pdf.worker.mjs';
    if (!(<any>Promise).try) {
      (<any>Promise).try = (fn, ...args) => new Promise((res, rej) => {
        try { res(fn(...args)); } catch (e) { rej(e); }
      });
    }
    var fileReader = new FileReader();
    if (file.type === 'application/pdf') {
      fileReader.readAsArrayBuffer(file);

      return new Promise(function (resolve, reject) {
        fileReader.onloadend = async function (ev) {
          let base64Data = fileReader.result as ArrayBuffer;
          const countPromises = [];

          if (base64Data.byteLength != 0) {
            //Códigos dos possíveis objetos de imagens presentes em ficheiros PDF
            var pdfImgObjCodes = [74, 75, 83, 84, 89, 85, 88, 86, 87, 82, 90, 66];

            let pdfProcessing: Int8Array = new Int8Array(base64Data as ArrayBuffer);
            const pdf = await pdfjsLib.getDocument(pdfProcessing);
            try {
              for (let i = 1; i <= (await pdf.promise).numPages; i++) {
                const page = await (await pdf.promise).getPage(i);

                //Verificar se o ficheiro PDF contém conteúdo de texto
                const textContent = await page.getTextContent();
                countPromises.push(textContent.items.map((s: any) => s.str).join(''));

                //Verificar se o ficheiro PDF contém conteúdo de imagens
                const imgContent = await page.getOperatorList();
                imgContent.fnArray.map(q => {
                  if (pdfImgObjCodes.includes(q))
                    countPromises.push('Img');
                });
              }
            } catch (e) {
              resolve("InvalidPDF");
            }
          } else {
            resolve("EmptyPDF");
          }

          await Promise.all(countPromises).then(function (e) {
            let pdfContent = e.join('');

            if (pdfContent !== ' ') {
              resolve("ValidPDF");
            } else {
              resolve("EmptyPDF");
            }
          })
        }
      })

    }
  }

  emitListChange(isEdit : boolean): void {
    if (isEdit)
      this.itemList.splice(this.editIndex, 1, this.item);
    else
      this.itemList.push(this.item);

    this.listChanged.emit(this.itemList);
  }

  onEdit(isEdit: boolean) {
    //Necessário setar o touched em todos os inputs no seguinte de forma a que as mensagens de erro apareçam
    super.markTouched();

    if (!super.checkValid())
      return;

    // Preencher as propriedades em falta
    const doc = this.item;
    if ((<any>doc).description == undefined || (<any>doc).description == null) {
      (<any>doc).description = doc.designationTypeDescription;
    }

    //If a file was uploaded
    if (!isNullOrUndefined(this.uploadedFile)) {
      /* TODO: Is throwing an error, BE must resolves this */
      this.http.get('api/Workflow/ValidateInstance', { params: { workflowInstanceID: this.workflowInstanceId, role: this.instanceRole }})
        .subscribe((res: any) => {
          // RES é o resultado que vem do BE, decisão para continuar ou não
          if (res.message == 'OK') {
            this.loadingMaskService.setShowLoading(true, false);
            this.documentService.UploadFile_PM(this.uploadedFile, this.workflowInstanceId.toString(), this.deceasedIdentification.subscriberNumber.toString(), this.item.designationTypeCode).subscribe(result => {
              this.loadingMaskService.setShowLoading(false);
              if (result.stateCode == "OK") {
                this.item.fileID = result.fileID;
                if (!isEdit) this.item.isMandatoryFile = false;
                this.emitListChange(isEdit);
              }
              else {
                this.alertService.error(result.message);
              }
            }, error => this.loadingMaskService.setShowLoading(false));
          } else {
            //this.alertService.error(this.translateService.instant("Workflow.IsAlreadySubmited"));
            this.alertService.error(res.message);
          }
        });

      
    }
    else {
      this.emitListChange(isEdit);
    }
  }

/*  onRemove_old(isEdit: boolean) {

    var listToAlter = [...this.itemList];
    if (this.isEdit && this.item.isMandatoryFile.toString()!='true'){
      listToAlter.splice(this.editIndex, 1);
      this.listChanged.emit(listToAlter);
    }

    this.listChanged.emit(listToAlter);
  }//*/

  onRemove(isEdit: boolean) {

    var listToAlter = [...this.itemList];

    if (this.isEdit) {
      if (this.item.isMandatoryFile.toString() != 'true') {
        listToAlter.splice(this.editIndex, 1);
        this.listChanged.emit(listToAlter);
      } else {
        this.onClearFile(this.isEdit);
      }

    }

/*    if (this.isEdit && this.item.isMandatoryFile.toString() != 'true') {
      listToAlter.splice(this.editIndex, 1);
      this.listChanged.emit(listToAlter);
    }//*/

    this.listChanged.emit(listToAlter);
  }



  downloadDocument() {
    if (!isNullOrUndefined(this.item.fileID) && isNotNullOrUndefinedOrEmpty(this.item.fileID))
      this.documentService.DownloadFile(this.item.fileID.toString(), this.item.fileName, this.workflowInstanceId.toString(), this.deceasedIdentification.subscriberNumber.toString());
  }


  onClearFile(isEdit: boolean, emit: boolean = false) {

    this.uploadedFile = null;

    function clearItem(itm: models.DocumentVM_PM) {
      itm.fileName = '';
      itm.file = null;
      itm.fileID = null;
      itm.fileDescription = "";
      itm.fileObservation = "";
      itm.filePath = "";
    }

    clearItem(this.item);
    //this.item.fileName = '';
    //this.item.file = null;
    //this.item.fileID = null;
    //this.item.name = "";
    //this.item.observation = "";
    //this.item.filePath = "";

    if ((this.editIndex !== null) && !isNaN(this.editIndex)) {
      clearItem(this.itemList[this.editIndex]);
      //this.itemList[this.editIndex].fileName = '';
      //this.itemList[this.editIndex].file = null;
      //this.itemList[this.editIndex].fileID = null;  // -----<<<<
      //this.itemList[this.editIndex].name = "";
      //this.itemList[this.editIndex].observation = "";
    }//*/

    if (emit) {
      this.listChanged.emit(this.itemList);
    }

    return false;

  }


  public removeDisabled(): boolean {
    if (!this.isEdit) return false;

//    if (!this.isMandatoryDocumentation) return false;
    //return this.isMandatoryDocumentation && (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

    if (!this.isMandatoryDocumentation) return false;

    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

  }//*/


  /*
  public removeDisabled(): boolean {
    if (!this.isEdit) return false;

    if (!this.isMandatoryDocumentation) return false;

    return (this.item.isMandatoryFile.toString().toLowerCase() == 'true');

  }//*/

  public isNewItem():boolean {

    const isNew = (this.item.ifedore_chav == undefined || this.item.ifedore_chav == null)
    return isNew;
  }
  shouldEditName(code: string) {
    return code == 'ECL000' || code == 'MDP130' || code == 'MPO000';
  }

  sortDesignationType(a, b) {
    if (b.code == 'MDP130')
      return -1;
    if (a.code == 'MDP130')
      return 1;
    return a.description - b.description;
  }



  docDesignationChanged() {
    var dropdown = this.designationTypes;
    
    for (let i = 0; i < dropdown.length; i++) {
      if (dropdown[i].value === this.item.designationTypeCode) {
        this.item.designationTypeDescription = dropdown[i].description;
      }
    }

    this.item.fileDescription = null;
  }

  public nameChanged(): void {
    const beneficiary = this.beneficiariesList
      .find(el => el.value == this.item.beneficiaryID);
    this.item.ownerName = beneficiary.name;
    this.item.fileOwnerTypeCode = beneficiary.type;
  }
}


